<template>
	<div v-loading="loading" element-loading-text="获取数据中,请稍后" element-loading-spinner="el-icon-loading">
		<el-row :gutter="20">
			<el-col>
				<el-card>
					<el-col :xs="24" :sm="16" :md="16" style="margin-bottom: 20px;">
						<el-form inline size="small">
							<el-form-item>
								<el-input v-model="keywords" placeholder="产品名称" maxlength="30" clearable />
							</el-form-item>
							<el-form-item>
								<el-button type="primary" plain icon="el-icon-search" @click="Search()">搜索</el-button>
								<el-button type="info" plain @click="resetSearch()">重置</el-button>
								<el-divider direction="vertical"></el-divider>
								<el-button type="success" @click="addData()">新增授权书模板</el-button>
							</el-form-item>
						</el-form>
					</el-col>
				</el-card>
			</el-col>
		</el-row>
		<el-row style="margin-top:15px;">
			<el-card>
				<el-table :data="tableData" style="width: 100%; " stripe>
					<el-table-column label="模板名称" prop="template_name" sortable show-overflow-tooltip />
					<el-table-column label="备注" prop="template_remark"></el-table-column>
					<el-table-column label="文档">
						<template slot-scope="props">
							<el-link icon="el-icon-download" :underline="false" type="primary"
								@click="handleFileClick(props.row.template_file)" style="display: block;">
								{{ props.row.template_file.split('.').slice(0, 1).join('').replace('auth/template/','')}}
							</el-link>
						</template>
					</el-table-column>
					<el-table-column label="创建时间" prop="create_date" sortable>
						<template slot-scope="props">
							<span>
								{{
									props.row.create_date
										.split('T')
										.slice(0, 1)
										.join('')
								}}
							</span>
						</template>
					</el-table-column>
					<el-table-column label="更新时间" prop="update_date" sortable>
						<template slot-scope="props">
							<span>
								{{
									props.row.update_date
										.split('T')
										.slice(0, 1)
										.join('')
								}}
							</span>
						</template>
					</el-table-column>

					<el-table-column width="150" label="操作" align="center">
						<template slot-scope="scope">
							<el-button-group>
								<el-button size="mini" icon="el-icon-edit"
									@click="updateData(scope.$index, scope.row)">改</el-button>
								<el-button type="danger" size="mini" icon="el-icon-delete"
									@click="deleteData(scope.$index, scope.row)">删</el-button>
							</el-button-group>
						</template>
					</el-table-column>
				</el-table>
			</el-card>
		</el-row>

		<!-- 分页 -->
		<el-row class="paginator hidden-sm-and-down">
			<el-pagination background :current-page.sync="currentPage" layout="total, sizes, prev, pager, next"
				:total="totalItems" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
				@current-change="handleCurrentChange" @size-change="handleSizeChange" />
		</el-row>

		<el-row class="paginator hidden-sm-and-up">
			<el-pagination background :current-page.sync="currentPage" layout="prev, pager, next" :total="totalItems"
				:page-size="pageSize" @current-change="handleCurrentChange" @size-change="handleSizeChange"
				prev-text="上一页" next-text="下一页" :pager-count="5" />
		</el-row>

		<!-- 新增数据表单 -->
		<el-dialog title="新增产品" :visible.sync="formAddDialogVisible" :close-on-click-modal="false"
			:close-on-press-escape="false" :show-close="false" :width="'60%'" :fullscreen="ifFullScreen">
			<el-form ref="formAddTemplate" :rules="rules" :model="formAddTemplate" :label-width="formLabelWidth"
				size="mini">
				<el-form-item label="模板名称" prop="template_name">
					<el-input v-model="formAddTemplate.template_name" type="textarea" clearable maxlength="250" autosize
						show-word-limit />
				</el-form-item>
				<el-form-item label="模板备注" prop="template_remark">
					<el-input v-model="formAddTemplate.template_remark" type="textarea" clearable maxlength="100"
						autosize show-word-limit />
				</el-form-item>
				<el-form-item label="模板文件" prop="template_file">
					<el-upload action="none" :auto-upload="false" accept=".doc,.docx" :multiple="false"
						:on-change="handleChange" :on-remove="handleRemove" :file-list="fileList">
						<el-button size="small" type="primary">点击上传</el-button>
						<div slot="tip" class="el-upload__tip">只能上传单个word文档</div>
					</el-upload>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="resetForm('formAddTemplate')">取 消</el-button>
				<el-button type="danger" @click="submitAddForm('formAddTemplate')">提 交</el-button>
			</div>
		</el-dialog>

		<!-- 更新数据表单 -->
		<el-dialog title="修改产品" :visible.sync="formUpdateDialogVisible" :close-on-click-modal="false"
			:close-on-press-escape="false" :show-close="false" :fullscreen="ifFullScreen">
			<el-form ref="formUpdateTemplate" :rules="rules" :model="formUpdateTemplate" :label-width="formLabelWidth"
				size="mini">

				<el-form-item label="模板名称" prop="template_name">
					<el-input v-model="formUpdateTemplate.template_name" type="textarea" clearable maxlength="250"
						autosize show-word-limit />
				</el-form-item>
				<el-form-item label="模板备注" prop="template_remark">
					<el-input v-model="formUpdateTemplate.template_remark" type="textarea" clearable maxlength="100"
						autosize show-word-limit />
				</el-form-item>
				<el-form-item label="模板文件" prop="template_file">
					<el-upload action="none" :auto-upload="false" accept=".doc,.docx" :multiple="false"
						:on-change="handleChangeUpdate" :on-remove="handleRemoveUpdate" :file-list="fileList">
						<el-button size="small" type="primary">点击上传</el-button>
						<div slot="tip" class="el-upload__tip">只能上传单个word文件</div>
					</el-upload>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="resetForm('formUpdateTemplate')">取 消</el-button>
				<el-button type="primary" @click="submitUpdateForm('formUpdateTemplate')">提 交</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>

	export default {
		inject: ['reload', 'logout'],
		data() {
			return {
				tableData: [],
				fileList: [],
				keywords: '',
				formAddDialogVisible: false,
				formUpdateDialogVisible: false,
				ifFullScreen: false,
				formAddTemplate: {
					pk: '',
					template_name: '',
					template_remark: '',
					template_file: '',
				},
				formUpdateTemplate: {
					pk: '',
					template_name: '',
					template_remark: '',
					template_file: '',
				},
				//新增和更新表单的验证规则
				rules: {
					template_name: [{
						required: true,
						message: '请输入模板名称',
						trigger: 'blur'
					}, {
						max: 40,
						message: '长度不超过40个字',
						trigger: 'blur'
					}],
					template_file: [{
						required: true,
						message: '请上传文件',
						trigger: 'blur'
					}]
				},
				formLabelWidth: '80px',
				totalItems: 100,
				currentPage: 1,
				pageSize: 20,
				deleteItemPk: '',
				loading: false
			};
		},
		mounted() {
			this.getData();
			this.ifFullScreen = document.body.clientWidth > 720 ? false : true;
		},
		methods: {
			//通用函数-获取数据
			getData() {
				let that = this;
				this.$axios
					.get('/apia/get/authtemplate/', {
						params: {
							keywords: that.keywords,
							currentpage: that.currentPage,
							pagesize: that.pageSize
						}
					})
					.then(function(response) {
						if (response.data.code == '401') {
							that.logout();
						} else {
							let temp_data = response.data.data;
							that.tableData = response.data.data;
							that.totalItems = response.data.totalItemNum;
						}
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			//通用功能 - 关键字搜索
			Search() {
				this.getData();
			},
			//新增数据-对话框
			addData() {
				this.formAddDialogVisible = true;
				this.fileList = [];
			},
			//新增数据-提交
			submitAddForm(formName) {
				this.$refs[formName].validate(valid => {
					if (valid) {
						let that = this;
						let fd = new FormData();
						let formData = this.formAddTemplate;
						//添加表单数据
						for (let key in formData) {
							fd.append(key, formData[key]);
						}
						this.$axios({
								url: '/apia/add/authtemplate/',
								method: 'post',
								data: fd,
								headers: {
									'Content-Type': 'multipart/form-data'
								}
							})
							.then(function(res) {
								if (res.data.code == '200') {
									that.reload();
								} else {
									that.$message({
										message: res.data.message,
										type: 'warning'
									});
								}
							})
							.catch(function(error) {
								console.log(error);
							});
					} else {
						return false;
					}
				});
			},
			//新增数据 - 重置表单
			resetForm(formName) {
				this.$refs[formName].resetFields();
				this.formAddDialogVisible = false;
				this.formUpdateDialogVisible = false;
				this.fileList = [];
			},
			//新增数据 - 上传插件变更文件
			handleChange(file, fileList) {
				this.formAddTemplate.template_file = file.raw;
				this.fileList = fileList.slice(-1);
			},
			//新增数据 - 上传插件移除文件
			handleRemove(file, fileList) {
				this.formAddTemplate.template_file = null;
				// this.fileList = [];
			},
			//更新数据 - 上传插件变更文件
			handleChangeUpdate(file, fileList) {
				this.formUpdateTemplate.template_file = file.raw;
				this.fileList = fileList.slice(-1);

			},
			//更新数据 - 上传插件移除文件
			handleRemoveUpdate(file, fileList) {
				this.formUpdateTemplate.template_file = null;
				// this.fileList = [];
			},

			//更新数据 - 对话框
			updateData(index, row) {
				this.fileList = [];
				//解除双向绑定
				this.formUpdateTemplate = JSON.parse(JSON.stringify(row));

				let tempData = this.formUpdateTemplate
				let newObj = Object.create({
					name: tempData.template_file.replace('auth/template/', ''),
					url: this.$domainPrefix + tempData.template_file,
				});
				this.fileList.push(newObj);
				this.formUpdateDialogVisible = true;
			},
			//更新数据-提交
			submitUpdateForm(formName) {
				this.$refs[formName].validate(valid => {
					if (valid) {
						let that = this;
						let fd = new FormData();
						let formData = this.formUpdateTemplate;
						console.log(formData);
						//遍历添加表单数据
						for (let key in formData) {
							fd.append(key, formData[key]);
						}
						this.$axios({
								url: '/apia/update/authtemplate/',
								method: 'post',
								data: fd,
								headers: {
									'Content-Type': 'multipart/form-data'
								}
							})
							.then(function(res) {
								if (res.data.code == '200') {
									that.getData();
									that.formUpdateDialogVisible = false;
								} else {
									that.$message({
										message: res.data.message,
										type: 'warning'
									});
								}
							})
							.catch(function(error) {
								console.log(error);
							});
					} else {
						return false;
					}
				});
			},
			//删除数据 - 对话框
			deleteData(index, row) {
				let deleteItemPk = JSON.parse(JSON.stringify(row)).pk;
				this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					})
					.then(() => {
						this.submitDeleteData(deleteItemPk);
					})
					.catch(() => {});
			},
			//删除数据-提交
			submitDeleteData(dataPk) {
				let that = this;
				let fd = new FormData();
				fd.append('pk', dataPk);
				this.$axios({
						url: '/apia/delete/authtemplate/',
						method: 'post',
						data: fd,
						headers: {
							'Content-Type': 'multipart/form-data'
						}
					})
					.then(function(res) {
						// console.log(res.data);
						if (res.data.code == '200') {
							that.reload();
						} else {
							that.$message({
								message: res.data.message,
								type: 'warning'
							});
						}
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			// 打开word文件
			handleFileClick(item) {
				window.open(this.$domainPrefix + item, '_blank')
			},
			//分页跳转
			handleCurrentChange(val) {
				this.currentPage = val;
				this.getData();
			},
			//每页显示条数更改
			handleSizeChange(val) {
				this.pageSize = val;
				this.getData();
			},
			// 重置搜索
			resetSearch() {
				this.currentPage = 1;
				this.keywords = "";
				this.getData();
			},
		}
	};
</script>

<style>
	.demo-table-expand .el-form-item {
		margin: 0;
		padding: 0;
		width: 100%;
	}
</style>